module.exports = __webpack_public_path__ + "img/02-6IQVIA一站式多渠道客户营销管理平台.2ec1bb4c.png";